
import api from "@/api";
import http from "@/api/http";
export default {
  namespaced: true,
  state: {
    user: null,
    token: localStorage.getItem("user-token") || null,
    guestData: null,
    userReviews: null,
    userCards: null,
    oneSignalUserId: null, // default
    oneSignalPlayerId: null,
  },

  getters: {
    isAuthenticated: (state) => !!state.token && !!state.user,
    getOneSignalUserId: (state) => { return state.oneSignalUserId },
    getOneSignalPlayerId: (state) => { return state.oneSignalPlayerId },
  },

  mutations: {
    SET_AUTH: (state, res) => {
      state.token = res.token;
      state.user = res;
      localStorage.setItem("user-token", res.token);
      http.defaults.headers.common["Authorization"] = "Bearer " + res.token;
      
    },
    CLEAR_AUTH: (state) => {
      state.token = null;
      state.user = null;
      state.userReviews = null; 
      state.userCards = null;
      state.oneSignalUserId = null;
      delete http.defaults.headers.common["Authorization"];
      localStorage.removeItem("user-token")
    },
    SET_USER: (state, user) => {
      state.user = user;
    },
    USER_USER_CARDS: (state, userCards) => {
      state.userCards = userCards;
    },
    SET_USER_REVIEWS: (state, userReviews) => {
      state.userReviews = userReviews;
    },
    SET_GUEST_DATA: (state, _guestData) => {
      state.guestData = _guestData;
    },
    SET_ONE_SIGNAL_USER_ID: (state, userId) => {
      state.oneSignalUserId = userId;
    },
    SET_ONE_SIGNAL_PLAYER_ID: (state, playerId) => {
      state.oneSignalPlayerId = playerId;
    },
  },


  actions: {
    authRequest: ({ commit, dispatch }, { email, password }) => {
      return new Promise((resolve, reject) => {
        api.auth
          .login(email, password)
          .then((response) => {
            commit("SET_AUTH", response.data);
            dispatch("fetchAuthUser");
            resolve(response);
          })
          .catch((e) => {
            dispatch("clearUserData");
            reject(e.response);
          });
      });
    },
    updateUserRequest: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        api.auth
          .userUpdate(data)
          .then((response) => {
            commit("SET_USER", response.data);
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    authSocialRequest: ({ commit, dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        api.auth
          .socialLogin(payload)
          .then((response) => {
            if (response.config.data) {
              try {
                const data = JSON.parse(response.config.data);
                commit('setProviderName', data.provider_name)
              } catch (e) { }
            }
            commit("SET_AUTH", response.data);
            dispatch("fetchAuthUser");
            resolve(response);
          })
          .catch((e) => {
            dispatch("clearUserData");
            reject(e.response);
          });
      });
    },
    fetchAuthUser: ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {
        api.auth
          .user()
          .then((res) => {
            commit("SET_USER", res.data);
            dispatch("fetchUserCardsRequest");
            resolve();
          })
          .catch((e) => {
            dispatch("clearUserData");
            reject(e.response);
          });
      });
    },
    logoutRequest: ({ dispatch }) => {
      return new Promise((resolve, reject) => {
        api.auth
          .logout()
          .then(() => {
            dispatch("clearUserData");
            resolve();
          })
          .catch((e) => {
            dispatch("clearUserData");
            reject(e.response);
          });
      });
    },
    addNewAddress: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        api.address
          .postNewAddress(data)
          .then((res) => {
            dispatch("fetchAuthUser");
            resolve(res);
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    primaryAddressRequest: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        api.address
          .primaryAddress(data)
          .then(() => {
            dispatch("fetchAuthUser");
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    deleteAddress: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        api.address
          .postdeleteAddress(data)
          .then(() => {
            dispatch("fetchAuthUser");
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    updateAddressRequest: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        api.address
          .updateAddress(data)
          .then(() => {
            dispatch("fetchAuthUser");
            resolve(data);
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    fetchUserCardsRequest: ({ commit }) => {
      return new Promise((resolve, reject) => {
        api.card
          .getCards()
          .then((res) => {
            commit("USER_USER_CARDS", res.data);
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    addUserCardRequest: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        api.card
          .addUserCard(data)
          .then(() => {
            dispatch("fetchUserCardsRequest");
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    deleteUserCardRequest: ({ dispatch }, idCard) => {
      return new Promise((resolve, reject) => {
        api.card
          .deleteCard(idCard)
          .then(() => {
            dispatch("fetchAuthUser");
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    addToFavorite: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        api.favorit
          .postToFavorite(data)
          .then(() => {
            dispatch("locationStore/fetchCategories", data.location_id, { root: true });
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    deleteFavorite: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        api.favorit
          .deleteUserFavorite(data.menu_item_id, data.location_id)
          .then(() => {
            dispatch("locationStore/fetchCategories", data.location_id, { root: true });
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    storeGuestData: ({ commit }, data) => {
      commit("SET_GUEST_DATA", data);
    },
    getUserReviewsRequest: ({ commit }) => {
      return new Promise((resolve, reject) => {
        api.reviews
          .getUserReviews()
          .then((response) => {
            commit("SET_USER_REVIEWS", response.data);
            resolve(response);
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    saveOneSignalUserId: ({ commit }, userId) => {
      commit('SET_ONE_SIGNAL_USER_ID', userId)
    },
    saveOneSignalPlayerId: ({ commit }, playerId) => {
      commit('SET_ONE_SIGNAL_PLAYER_ID', playerId)
    },
    clearUserData : ({ dispatch, commit}) =>{
      dispatch('cartStore/clearNewCart', null, { root: true })
      dispatch('locationStore/clearData', null, { root: true })
      commit('CLEAR_AUTH')
    }
  }
}